/**
 * Clamper.
 * Detects proper clamp min/max.
 *
 * @param {number} a Current value to cut off
 * @param {number} min One side limit
 * @param {number} max Other side limit
 *
 * @return {number} Clamped value
 */
module.exports = require('./wrap')(function (a, min, max) {
  return max > min ? Math.max(Math.min(a, max), min) : Math.max(Math.min(a, min), max);
});